<template>
  <div class="text-center mt-2">

    <div class="d-flex justify-content-center">
      <add-community-button/>
      <favorite-button/>
    </div>

    <div class="mt-3" id="notification_message">
      <div class="message" v-if="existSuccessResult()">
        <svg height="28px" style="cursor: default" version="1.1" viewBox="0 0 28 28" width="28px"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <path
              d="M11,18.5857864 L5.70710678,13.2928932 C5.31658249,12.9023689 4.68341751,12.9023689 4.29289322,13.2928932 C3.90236893,13.6834175 3.90236893,14.3165825 4.29289322,14.7071068 L10.2928932,20.7071068 C10.6834175,21.0976311 11.3165825,21.0976311 11.7071068,20.7071068 L23.7071068,8.70710678 C24.0976311,8.31658249 24.0976311,7.68341751 23.7071068,7.29289322 C23.3165825,6.90236893 22.6834175,6.90236893 22.2928932,7.29289322 L11,18.5857864 Z"></path>
        </svg>
        <span class="message__text">{{ getMessage() }}</span>
      </div>

      <div class="message" v-if="existErrorResult()">
        <svg height="28px" style="cursor: default" version="1.1" viewBox="0 0 28 28" width="28px"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <path
              d="M6.29289322,6.29289322 C6.68341751,5.90236893 7.31658249,5.90236893 7.70710678,6.29289322 L7.70710678,6.29289322 L14,12.585 L20.2928932,6.29289322 C20.6533772,5.93240926 21.2206082,5.90467972 21.6128994,6.20970461 L21.7071068,6.29289322 C22.0976311,6.68341751 22.0976311,7.31658249 21.7071068,7.70710678 L21.7071068,7.70710678 L15.415,14 L21.7071068,20.2928932 C22.0675907,20.6533772 22.0953203,21.2206082 21.7902954,21.6128994 L21.7071068,21.7071068 C21.3165825,22.0976311 20.6834175,22.0976311 20.2928932,21.7071068 L20.2928932,21.7071068 L14,15.415 L7.70710678,21.7071068 C7.34662282,22.0675907 6.77939176,22.0953203 6.38710056,21.7902954 L6.29289322,21.7071068 C5.90236893,21.3165825 5.90236893,20.6834175 6.29289322,20.2928932 L6.29289322,20.2928932 L12.585,14 L6.29289322,7.70710678 C5.93240926,7.34662282 5.90467972,6.77939176 6.20970461,6.38710056 Z"></path>
        </svg>
        <span class="message__text">{{ getMessage() }}</span>
      </div>
    </div>

<!--    <div class="btn shadow-sm w-auto mr-2" @click="clickAddToGroup">-->
<!--      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Page-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="add_24"> <rect id="Bounds" x="0" y="0" width="24" height="24"></rect> <path d="M13.000006,11 L19.5,11 C20.0522847,11 20.5,11.4477153 20.5,12 C20.5,12.5522847 20.0522847,13 19.5,13 L13.000006,13 L13.000006,19.500084 C13.000006,20.0523464 12.5523089,20.5000435 12.0000465,20.5000435 C12.000032,20.5000435 12.0000175,20.5000435 12.000003,20.5000435 C11.4477096,20.5000195 11,20.0522904 11,19.499997 L11,13 L4.5,13 C3.94771525,13 3.5,12.5522847 3.5,12 C3.5,11.4477153 3.94771525,11 4.5,11 L11,11 L11,4.50000301 C11,3.9477166 11.4477166,3.5 12.000003,3.5 C12.5522894,3.5 13.000006,3.9477166 13.000006,4.50000301 L13.000006,11 Z" id="Mask" fill="currentColor"></path> </g> </g> </svg>-->
<!--      Добавить в сообщество-->
<!--    </div>-->

<!--    <div class="btn shadow-sm w-auto" @click="clickAddToFavorite">-->
<!--      <svg v-if="! checkFavorite() && this.favoriteEvent.added === false"  fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M12.554 4.694a.6.6 0 00-1.108 0l-1.614 3.9a.9.9 0 01-.774.554l-4.125.266a.6.6 0 00-.357 1.05l3.267 2.859a.9.9 0 01.282.888l-.93 3.852a.6.6 0 00.883.66l3.472-2.003a.9.9 0 01.9 0l3.472 2.004a.6.6 0 00.883-.66l-.93-3.853a.9.9 0 01.282-.888l3.267-2.858a.6.6 0 00-.357-1.05l-4.125-.267a.9.9 0 01-.774-.554zm-2.772-.689c.818-1.976 3.618-1.976 4.436 0l1.4 3.383 3.565.23c2.136.138 3.037 2.792 1.426 4.201l-2.856 2.5.802 3.322c.494 2.05-1.706 3.696-3.533 2.642L12 18.539l-3.022 1.744C7.15 21.337 4.95 19.69 5.445 17.64l.802-3.322-2.856-2.5c-1.611-1.41-.71-4.063 1.426-4.201l3.566-.23z" fill="currentColor" fill-rule="evenodd"/></svg>-->
<!--      <svg v-if="checkFavorite() || favoriteEvent.added === true" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> &lt;!&ndash; Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch &ndash;&gt; <title>favorite_24</title> <desc>Created with Sketch.</desc> <defs></defs> <g id="Page-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="favorite_24"> <rect id="Bounds" x="0" y="0" width="24" height="24"></rect> <path d="M15.3434708,8.48495901 L19.7730469,8.90993568 C21.3143318,9.05780764 21.7870223,10.5633855 20.5968604,11.5525336 L17.1289997,14.4346857 L18.4163875,19.1299607 C18.8391688,20.6719004 17.5274886,21.6053368 16.2137206,20.6773504 L12.0000276,17.7009879 L7.78633462,20.6773504 C6.47787145,21.6015898 5.1608292,20.6721094 5.58366778,19.1299607 L6.8710556,14.4346857 L3.40319488,11.5525336 C2.20803123,10.5592286 2.67886498,9.0584719 4.2267675,8.90993737 L8.65552864,8.48495974 L10.606729,3.98631517 C11.2177677,2.57751782 12.7826524,2.57822375 13.3931825,3.98646084 L15.3434708,8.48495901 Z" id="Mask" fill="currentColor" fill-rule="nonzero"></path> </g> </g> </svg>-->
<!--    </div>-->

<!--    <div class="message" v-if="groupEvent.result === true || favoriteEvent.result === true">-->
<!--      <svg height="28px" style="cursor: default" version="1.1" viewBox="0 0 28 28" width="28px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M11,18.5857864 L5.70710678,13.2928932 C5.31658249,12.9023689 4.68341751,12.9023689 4.29289322,13.2928932 C3.90236893,13.6834175 3.90236893,14.3165825 4.29289322,14.7071068 L10.2928932,20.7071068 C10.6834175,21.0976311 11.3165825,21.0976311 11.7071068,20.7071068 L23.7071068,8.70710678 C24.0976311,8.31658249 24.0976311,7.68341751 23.7071068,7.29289322 C23.3165825,6.90236893 22.6834175,6.90236893 22.2928932,7.29289322 L11,18.5857864 Z"></path></svg>-->
<!--      <span class="message__text" v-if="groupEvent.result === true">Приложение установлено в сообщество!</span>-->

<!--      <span class="message__text" v-if="favoriteEvent.alreadyAdded === false && favoriteEvent.result === true">Приложение добавлено в избранное!</span>-->
<!--      <span class="message__text" v-if="favoriteEvent.alreadyAdded === true">Приложение уже в избранном!</span>-->
<!--    </div>-->

<!--    <div class="message" v-if="groupEvent.result === false || favoriteEvent.result === false">-->
<!--      <svg height="28px" style="cursor: default" version="1.1" viewBox="0 0 28 28" width="28px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M6.29289322,6.29289322 C6.68341751,5.90236893 7.31658249,5.90236893 7.70710678,6.29289322 L7.70710678,6.29289322 L14,12.585 L20.2928932,6.29289322 C20.6533772,5.93240926 21.2206082,5.90467972 21.6128994,6.20970461 L21.7071068,6.29289322 C22.0976311,6.68341751 22.0976311,7.31658249 21.7071068,7.70710678 L21.7071068,7.70710678 L15.415,14 L21.7071068,20.2928932 C22.0675907,20.6533772 22.0953203,21.2206082 21.7902954,21.6128994 L21.7071068,21.7071068 C21.3165825,22.0976311 20.6834175,22.0976311 20.2928932,21.7071068 L20.2928932,21.7071068 L14,15.415 L7.70710678,21.7071068 C7.34662282,22.0675907 6.77939176,22.0953203 6.38710056,21.7902954 L6.29289322,21.7071068 C5.90236893,21.3165825 5.90236893,20.6834175 6.29289322,20.2928932 L6.29289322,20.2928932 L12.585,14 L6.29289322,7.70710678 C5.93240926,7.34662282 5.90467972,6.77939176 6.20970461,6.38710056 Z"></path></svg>-->
<!--      <span class="message__text">Произошла ошибка! Попробуйте позже.</span>-->
<!--    </div>-->
  </div>
</template>

<script>
import bridge from "@vkontakte/vk-bridge";
import {store} from "@/store";
import AddCommunityButton from "@/components/FavoriteButtons/AddCommunityButton";
import FavoriteButton from "@/components/FavoriteButtons/FavoriteButton";

export default {
  name: "FavoriteButtons",
  components: {FavoriteButton, AddCommunityButton},
  data() {
    return {
      groupEvent: {
        result: null,
      },
      favoriteEvent: {
        result: null,
        added: false,
        alreadyAdded: false,
      },
      isSending: false,
    }
  },
  mounted() {
    if (store.state.launchParams["vk_is_favorite"]) {
      this.favoriteEvent.alreadyAdded = true;
    }
  },
  methods: {
    clickAddToGroup() {
      bridge.send("VKWebAppAddToCommunity").then(() => {
        this.groupEvent.result = true;
      }).catch((e) => {
        // User denied
        if (e.error_data.error_code !== 4) {
          this.groupEvent.result = false;
        }
      }).finally(() => {
        setTimeout(() => {
          this.groupEvent.result = null;
        }, 3000);
      });
    },
    clickAddToFavorite() {
      if (this.favoriteEvent.added === true) {
        this.favoriteEvent.result = true;
        this.favoriteEvent.alreadyAdded = true;

        setTimeout(() => {
          this.favoriteEvent.result = null;
        }, 3000)

        return;
      }

      bridge.send("VKWebAppAddToFavorites").then((e) => {
        console.log(e)
        this.favoriteEvent.result = true;
        this.favoriteEvent.added = true;
      }).catch((e) => {
        console.log(e)

        // User denied
        if (e.error_data.error_code !== 4) {
          this.favoriteEvent.result = false;
        }

      }).finally(() => {
        setTimeout(() => {
          this.favoriteEvent.result = null;
        }, 3000);
      });
    },
    checkFavorite() {
      return store.state.launchParams["vk_is_favorite"] === "1";
    },
    existSuccessResult() {
      return this.favoriteResult.result === true || this.communityResult.result === true;
    },
    existErrorResult() {
      return this.favoriteResult.result === false || this.communityResult.result === false;
    },
    getMessage() {
      if (this.favoriteResult.message !== "") {
        return this.favoriteResult.message;
      }
      if (this.communityResult.message !== "") {
        return this.communityResult.message;
      }
    }
  },
  computed: {
    favoriteResult() {
      return store.state.favoriteButton;
    },
    communityResult() {
      return store.state.addCommunityButton;
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../scss/partials/buttons";
  .btn {
    @extend .btn-share;
    border-radius: 5px;
    height: 36px;
  }

  .message {
    text-align: center;
    margin-top: 14px;

    & svg {
      fill: var(--zodiac-svg-fill);
    }
  }

  .message__text {
    color: var(--default-text-color);
  }
</style>